export interface IPNSOrganization {
  id: string;
  updatedBy: string;
  abbreviation: string;
  name: string;
  orgType: string;
  externalID: string;
}
